module.exports = __webpack_public_path__ + "static/media/image-courses-1.eb0c01da.png";